import { withTranslation } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import { Button, Link } from "@components/core";
import DrawerIcon from "@components/views/Drawer/DrawerIcon";
import { useOpenDrawer } from "@hooks/use-drawer";

function NavbarCTAHandler({ t }) {
  const openDrawer = useOpenDrawer();
  const user = useCurrentUser();
  const userState = user?.state;
  const restartAtDate = user?.subscription?.restart_at;

  function displayRedirectTunnelButton(title, href) {
    return (
      <Link href={href}>
        <Button
          size="sm"
          style={{ zIndex: 2 }}
          className="px-3"
        >
          {title}
        </Button>
      </Link>
    );
  }

  function displayOpenDrawerButton() {
    return (
      <Button
        size="sm"
        style={{ zIndex: 2 }}
        onClick={openDrawer}
      >
        {t("common:navbar.restart")}
      </Button>
    );
  }

  function displayButton() {
    switch (userState) {
      case "lead":
        return displayRedirectTunnelButton(t("common:navbar.i_begin"), "/je-commence");
      case "subscriber":
        return <DrawerIcon />;
      case "suspended":
        if (restartAtDate) return displayOpenDrawerButton();

        return displayRedirectTunnelButton(t("common:navbar.restart"), "/je-commence");
      default:
        return displayRedirectTunnelButton(t("common:navbar.i_begin"), "/je-commence");
    }
  }

  return displayButton();
}

export default withTranslation("common")(NavbarCTAHandler);
